import axios from "axios";
import { useMutation } from "react-query";
import { END_POINT } from "config/environment";
import {
  ApiDataResponse,
  AuthorizationPermission,
  CreatePermissionRequest,
} from "../types";

export const addPermission = async ({
  token,
  ...payload
}: CreatePermissionRequest): Promise<ApiDataResponse<AuthorizationPermission>> => {
  const url = `${END_POINT.BASE_URL}/v1/administrator/authorization/permissions`;
  const config = {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
  };

  const response = await axios.post<ApiDataResponse<AuthorizationPermission>>(
    url,
    payload,
    config
  );
  return response.data;
};

export const useAddPermission = () => {
  return useMutation(addPermission);
};
